import React from "react";
import { Elements, StripeProvider } from "react-stripe-elements";

export default ({ apiKey, children }) => (
  <StripeProvider apiKey={apiKey}>
    <Elements>{children}</Elements>
  </StripeProvider>
);
